module.exports = __webpack_public_path__ + "img/dentalia_logo.95ada295.png";